import { ChevronLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface PageHeaderProps {
  title: string
  subtitle?: React.ReactNode
  backTo?: string
  children?: React.ReactNode
  breadcrumbs?: { label: string; to?: string }[]
}

export default function PageHeader({ title, subtitle, backTo, children, breadcrumbs }: PageHeaderProps) {
  const navigate = useNavigate()

  return (
    <div className="space-y-2">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav aria-label="Breadcrumb" className="flex items-center text-sm text-gray-500 dark:text-gray-400">
          {breadcrumbs.map((crumb, i) => (
            <span key={i} className="flex items-center">
              {i > 0 && <span className="mx-2 text-gray-300 dark:text-gray-600">/</span>}
              {crumb.to ? (
                <button
                  onClick={() => navigate(crumb.to!)}
                  className="hover:text-gray-900 dark:hover:text-gray-200"
                >
                  {crumb.label}
                </button>
              ) : (
                <span className="text-gray-900 dark:text-white">{crumb.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}

      {!breadcrumbs && backTo && (
        <button
          onClick={() => navigate(backTo)}
          className="inline-flex items-center text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
        >
          <ChevronLeft className="h-4 w-4 mr-1" aria-hidden="true" />
          Back
        </button>
      )}

      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>}
        </div>
        {children && <div className="flex items-center gap-2">{children}</div>}
      </div>
    </div>
  )
}
